import { Component } from "@angular/core";

@Component({
    selector: "page-porta_pago",
    templateUrl: "./portal_pago.component.html",
    styleUrls: ["./portal_pago.component.css"]
})

export class PortalPagoComponent {
    
}